<template>
    <div>
        <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWe66pj.png" width="100%" />
        <div class="inputForm">
            <van-row style="margin-top: 1rem;">
                <vue-qr :margin="0" :text="taolijin.linkUrl"
                        v-if="taolijin.linkUrl" :size="185" :callback="qrCallback"></vue-qr>
            </van-row>
            <van-row style="margin-top: 1rem;">
                {{taolijin.name}}
            </van-row>

            <div style="font-size:1rem;margin-top:2rem;">
                温馨提示<br/>
                完成淘宝特价版首购后，次日进入本页面<br/>
                选择任意商品，0元抢购
            </div>
        </div>
    </div>
</template>

<script>
    import taolijinApi from '@/api/taolijin';
    import vueQr from 'vue-qr';

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                query: {
                    encryptId: this.$route.query.encryptId,
                },
                taolijin: {},
            }
        },
        methods: {
            qrCallback(url, id) {
            },
        },
        created() {
            taolijinApi.getByEncryptId(this.query.encryptId).then((result) => {
                this.taolijin = result.data;
            })
        },
    }

</script>

<style lang="scss" scoped>

    .inputForm {
        background-color: white;
        width: 85%;
        margin: 0 auto;
        padding: 1rem;
        text-align: center;
    }

</style>
